export default __webpack_public_path__ + "942c6a8892e0158771c8366413fc8732.png";